import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonRegister.module.scss'

const ButtonRegister = () => {
  return (
    <div className={styles.buttonRegisterContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'register-button-submit'}
            defaultMessage={'Register'}
          />
        )}
        customClassnames={{container: styles.button}}
      />
    </div>
  );
};

export default ButtonRegister;
